import type { IVariantUrlRedirectFieldErrorCode } from '../types';
import type { MessageToast } from '~/modules/campaign/types';

import { ESetupGuideCampaignUrlRedirect, VARIANT_URL_REDIRECT_FIELD_ERROR_CODE } from '../types';
import { TOOLTIP_CAMPAIGN_VARIANT } from '~/modules/campaign/constants';
import { ICampaignType, IVariantType } from '~/modules/campaign/types';

export const CAMPAIGN_URL_REDIRECT_SAVE_BAR_ID = 'campaign-url-redirect-update';

export const PLATFORM_PRODUCT_DETAILS_QUERY_KEY = 'PlatformProductDetails';

export const VARIANT_URL_REDIRECT_SKELETON_WIDTH = '72px';

export const URL_REDIRECT_SETUP_GUIDE_SEEN_ACTION = 'STATUS';

export const DEFAULT_TRAFFIC_RATE = '0.5';

export const URL_REDIRECT_VARIANT_MSG: Record<'PICK' | 'REMOVE', MessageToast> = {
  PICK: {
    SUCCESS: 'Page selected',
    FAILED: 'Failed to select page',
  },
  REMOVE: {
    SUCCESS: 'Page removed',
    FAILED: 'Failed to remove page',
  },
};

export const EMPTY_VARIANT_SETUP_GUIDE_ID: Record<IVariantType, ESetupGuideCampaignUrlRedirect> = {
  [IVariantType.VARIANT_A]: ESetupGuideCampaignUrlRedirect.SET_CONTROL_URL,
  [IVariantType.VARIANT_B]: ESetupGuideCampaignUrlRedirect.SET_VARIANT_URL,
};

/** Same copy the listing and analytics screens read, so a URL variant is described one way everywhere. */
export const CAMPAIGN_URL_REDIRECT_VARIANT_TOOLTIP = TOOLTIP_CAMPAIGN_VARIANT[ICampaignType.URL];

// Not run through `t()`: i18next reads the `:` as its namespace separator and would strip the `https:` prefix.
export const CAMPAIGN_URL_REDIRECT_FIELD_PLACEHOLDER = 'https://example.myshopify.com/pages/name';

/** `{{variant}}` names the side already holding the URL — Control or Variant. */
export const VARIANT_URL_REDIRECT_FIELD_ERROR_MESSAGE: Record<
  IVariantUrlRedirectFieldErrorCode,
  string
> = {
  [VARIANT_URL_REDIRECT_FIELD_ERROR_CODE.INVALID_URL]: 'Invalid URL',
  [VARIANT_URL_REDIRECT_FIELD_ERROR_CODE.NOT_AVAILABLE_ON_ONLINE_STORE]:
    'Not available on Online Store.',
  [VARIANT_URL_REDIRECT_FIELD_ERROR_CODE.SELECTED_IN_CAMPAIGN]: 'Already selected for {{variant}}',
  [VARIANT_URL_REDIRECT_FIELD_ERROR_CODE.SELECTED_IN_OTHER_CAMPAIGN]:
    'Already selected in another experiment.',
  [VARIANT_URL_REDIRECT_FIELD_ERROR_CODE.LOOKUP_FAILED]:
    "Couldn't check this URL. Please try again.",
};

export const VARIANT_URL_REDIRECT_EDIT_CAMPAIGN_LABEL = 'Edit experiment';
